<template>
    <div class="Gre">
        <!-- s: header -->
        <header id="header-slidePanel">
            <h2>그레 내역</h2>
            <div class="btn_back">
                <a @click="slidePanelClose">
                    <img src="@/assets/images/btn_back.png" width="50" alt="이전" />
                </a>
            </div>
        </header>
        <!-- e: header -->
        <!-- s: contents -->
        <div class="contents-area-slidePanel">
            <h2 class="slidePanel-title clearfix">
                <div class="tab-menu pull-left width-85">
                    <ul>
                        <li :class="greTab == 'gre' ? 'active' : ''"
                            @click="greTab='gre'">
                            <a>나의 그래</a>
                        </li>
                        <li :class="greTab == 'point' ? 'active' : ''"
                            @click="greTab='point'">
                            <a>내사용/적립 조회</a>
                        </li>
                    </ul>
                </div>
            </h2>
            <!-- 나의그래 -->
            <div v-if="greTab == 'gre'">
                <div class="gre-point mrg-top-20">
                    <h3>사용가능</h3>
                    <h4>{{ grePointSummary.nUserTotalPoint | comma }}그레</h4>
                </div>
                <div class="gre-point mrg-top-20" @click="greOrderSlideView">
                    <h3 style="flex-basis:unset">
                        그레 상품 주문하기
                    </h3>
                </div>
                <div class="gre-expected">
                    <div class="gre-expected-point">
                        <h3>당월 소멸예정</h3>
                        <h4>{{ grePointSummary.nDelPointInMonth | comma }}그레</h4>
                    </div>
                    <p>그레의 유효기간은 적립 후 6개월입니다</p>
                </div>

                <div class="info-text mrg-top-40">
                    <h5>그레란?</h5>
                    <p>
                        질문 게시글에 답변한 댓글이 채택된 경우<br />
                        그레 점수가 지급됩니다.
                    </p>
                </div>
                <div class="info-text mrg-top-20">
                    <h5>그레 사용방법</h5>
                    <p>
                        홈페이지에서 그레 사용 이벤트를 진행할 때<br />
                        필요한 상품을 구매할 수 있습니다.
                    </p>
                </div>
            </div>
            <!-- 내사용/적립조회 -->
            <div v-else>
                <div class="form-box">
                    <div class="input-title"><span>검색기간</span></div>
                    <div class="input-box">
                        <div class="input-item">
                            <select v-model="searchMon">
                                <option value="1">최근 1개월</option>
                                <option value="3">최근 3개월</option>
                                <option value="6">최근 6개월</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="mrg-top-20">
                    <table width="100%">
                        <colgroup>
                            <col width="60%" />
                            <col width="20%" />
                            <col width="20%" />
                        </colgroup>
                        <thead>
                        <tr>
                            <th>내역</th>
                            <th>그레</th>
                            <th>잔여그레</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(data, index) in grePointHistory" :key="index">
                            <td class="text-left pdd-left-10">
                                <div class="table-contents">
                                    <h3>{{ data.strGreTypeDetail }}</h3>
                                    <h4 :class="{ use : (data.nGreType == '차감' ) }">{{ data.nGreType }}</h4>
                                    <p>{{ data.strRegDate| moment("YYYY.MM.DD") }}</p>
                                </div>
                            </td>
                            <td class="table-gre-point">{{ data.nGrePoint }}</td>
                            <td class="table-gre-result">{{ data.nGreRemainPoint }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <!-- e: contents -->
    </div>
</template>

<script>
export default {
    name: 'Gre',
    data() {
        return {
            greTab:'gre',           // 선택된 Tab
            grePointSummary:{},     // 나의그레정보
            grePointHistory:[],     // 내사용/적립 조회
            searchMon:1,            // 검색월
            page:1,                     // 페이지번호
            loading:false,              // 로딩여부
            listMore:true,              // infinite 종료여부
        }
    },
    // 감시자
    watch: {
        // tab 변경
        greTab(_new){
            if (_new == 'gre'){
                this.getGreMeSummary();
            }else{
                this.getGreMeHistory();
            }
        },
        searchMon(){
            this.page=1;
            this.loading=false;
            this.listMore=true;
            this.getGreMeHistory();
        }
    },
    // $el 생성전
    created(){
    },
    // $el 생성후
    mounted() {
        window.callbackBackKey = this.callbackBackKey;
        this.getGreMeSummary();
    },
    methods: {
        // APP 뒤로가기
        callbackBackKey(){
            this.slidePanelClose();
        },
        // 나의그래
        getGreMeSummary(){
            let param = {};
            this.ajaxGetAuth('/api/v1/gre/me/summary', param,this.getGreMeSummaryResult);
        },
        // 나의그래 결과
        getGreMeSummaryResult(response){
            if (response.result.code == 0){
                this.grePointSummary = response.oGrePoint.summary;
            }else{
                this.toastMsg(response.result.resultNoti.message,1500);
            }
        },
        // 그레상품주문하기 Slide
        greOrderSlideView(nUserNum){
            let props = {
                nUserNum : nUserNum,
            };
            const panel =this.$showPanel({
                component: () => import('@/views/slide/GreOrder.vue'),
                props: props,
                openOn: 'right',
                width:screen.width,
            });
            panel.promise.then(result => {
                window.callbackBackKey = this.callbackBackKey;
                if (result.result === "close"){
                    this.slidePanelClose(result);
                }
            });
        },
        // 내사용/적립 조회
        getGreMeHistory(){
            if (this.initLoading == false){
                return false;
            }

            if (this.listMore == false){
                return false;
            }

            this.loading = true;

            let nPage = this.page++
            let param = {};
            param.nPage = nPage;
            this.ajaxGetAuth('/api/v1/gre/me/history/'+this.searchMon+'/'+nPage, param, this.getGreMeHistoryResult);
        },
        // 내사용/적립 조회 결과
        getGreMeHistoryResult(response, varParam){
            if (response.result.code == 0){
                let vm = this;
                // 게시글 리스트
                response.oGrePoint.list.forEach(function (key) {
                    vm.grePointHistory.push(key)
                })

                // 현재 페이지와 마지막 페이지가 같은경우
                if(varParam.nPage == response.oGrePoint.setting.nMaxPage){
                    this.listMore = false;
                }
            }else{
                this.toastMsg(response.result.resultNoti.message,1500);
            }

            this.loading = false;
        },
    }
}
</script>

<style scoped>
    .gre-point{background: #f2f2f2;border-radius: 5px;flex: 1;display: flex;flex-direction: row;padding: 20px;}
    .gre-point h3{flex-basis: 100px;font-size: 15px;color: #000;line-height: 180%;}
    .gre-point h4{flex: 1;text-align: right;color: #0086ff;font-size: 18px;}
    .gre-expected {border-top: 1px solid #dfdfdf;border-bottom: 1px solid #dfdfdf;margin-top: 15px;padding: 20px 20px 20px 15px;}
    .gre-expected-point{flex: 1;display: flex;flex-direction: row;}
    .gre-expected-point h3{flex-basis: 150px;font-size: 15px;color: #000;line-height: 180%;}
    .gre-expected-point h4{flex: 1;text-align: right;color: #000;font-size: 18px;}
    .gre-expected p{color: #a4a4a4;}
    .form-box {font-size: 13px;}
    .form-box select {height: 40px;font-size: 13px;}

    .table-gre-point {font-size: 16px; color: #8d8d8d; font-weight: 600}
    .table-gre-result {font-size: 16px; color: #0086ff; font-weight: 600}

</style>
